(function () {
  'use strict';

  var OPEN_CLASS = 'site-header_search-open';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.header-search').forEach(function (wrapper) {
      var toggle = wrapper.querySelector('.header-search__toggle');
      var header = wrapper.closest('.site-header');
      var panelId = toggle ? toggle.getAttribute('aria-controls') : null;
      var panel = panelId ? document.getElementById(panelId) : null;
      var input = panel
        ? panel.querySelector('input[name="search"], input[type="search"], input[type="text"]')
        : null;

      if (!toggle || !header || !panel) {
        return;
      }

      toggle.setAttribute(
        'aria-expanded',
        header.classList.contains(OPEN_CLASS) ? 'true' : 'false'
      );

      toggle.addEventListener('click', function () {
        var isOpen = header.classList.toggle(OPEN_CLASS);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen && input) {
          window.setTimeout(function () {
            input.focus();
          }, 20);
        }
      });

      document.addEventListener('click', function (event) {
        var target = event.target;
        var isAutocompleteClick =
          target instanceof Element && target.closest('.ui-autocomplete');

        if (!header.contains(target) && !isAutocompleteClick) {
          header.classList.remove(OPEN_CLASS);
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          header.classList.remove(OPEN_CLASS);
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      });
    });
  });
})();